import { updateAttendanceForm } from '@/utils/attendanceFormHelper'

const store = {
  namespaced: true,
  state: () => ({
    id: 'biometria',
    name: 'Biometria',
    opened: true,
    showing: true,
    completed: false,
    multiple: true,
    value: [],
    scopes: ['ATTENDANCE', 'SURGERY', 'EXAM']
  }),
  mutations: {
    handleProps: (state, { key, value }) => {
      state[key] = value
    },
    handleFields: (state, { key, value }) => {
      state.fields[key] = value
    },
    addValue: (state, value) => {
      state.value.push(value)
    },
    setDefaultValue: (state, value) => {
      state.value = value ?? [
        { title: 'AL', olhoDireito: null, olhoEsquerdo: null },
        { title: 'ACD', olhoDireito: null, olhoEsquerdo: null }
      ]
    },
    checkComplete: state => {
      state.completed = Object.keys(state.value).some(
        key => state.value[key].olhoDireito || state.value[key].olhoEsquerdo
      )
    }
  },
  getters: {},
  actions: {
    handleProps(context, { key, value }) {
      context.commit('handleProps', { key, value })
      context.commit('checkComplete')

      if (
        context?.rootState?.attendance?.attendance?.id &&
        ['showing', 'opened'].includes(key)
      ) {
        const form = context?.rootGetters['attendance/form/getSelectedForm']
        const forms = form.forms
        const index = forms?.findIndex(form => {
          return form.id === context.state.id
        })

        if (index && index !== -1) {
          forms[index][key] = value
          form.forms = forms
          updateAttendanceForm(
            context?.rootState?.attendance?.attendance?.attendance_form?.id,
            { forms: forms }
          )
          context.dispatch(`attendance/form/updateAttendanceForms`, form, {
            root: true
          })
        }
      }
    },
    handleFields(context, { key, value }) {
      context.commit('handleFields', { key, value })
      context.commit('checkComplete')
    },
    addValue(context, value) {
      context.commit('addValue', value)
      context.commit('checkComplete')
    },
    setDefaultValue(context, value) {
      context.commit('setDefaultValue', value)
    }
  }
}

export default store
